<template>
	<div v-if="dataLoaded">
		<v-toolbar color="blue lighten-1" class="white--text">
			<v-icon color="white">public</v-icon>
			<v-toolbar-title>Zadania, kraje i priorytety projektu</v-toolbar-title>
		</v-toolbar>
		<div class="ma-4">
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<v-subheader><strong>Kraj główny</strong></v-subheader>
				</v-flex>
				<v-flex xs6>
					<div v-if="!data.mainCountry">brak</div>
					<div v-else>{{data.mainCountry}}</div>
				</v-flex>
			</v-layout>
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<div style="display: flex; flex-direction: row; justify-content: space-between">
						<v-subheader>
							<strong>{{getListLabel}}</strong>
						</v-subheader>
						<v-btn flat icon class="mr-5" @click="handleListExpansion">
							<v-icon>{{getListIcon}}</v-icon>
						</v-btn>
					</div>
				</v-flex>
				<v-flex xs6>
					<i v-if="!showList">Lista ukryta</i>
				</v-flex>
			</v-layout>
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs9>
					<v-expand-transition v-if="showList">
						<v-list three-line>
							<template v-for="item in data.areas">
								<v-list-tile :key="'area-' + item.areaId" avatar class="list-item">
									<v-list-tile-avatar>
										<v-icon>public</v-icon>
									</v-list-tile-avatar>
									<v-list-tile-content>
										<v-list-tile-title v-html="item.task + ' (' + item.country + ')'"
											style="font-size: 14px"></v-list-tile-title>
										<v-list-tile-sub-title
											v-html="'Priorytet: ' + item.priority"></v-list-tile-sub-title>
										<v-list-tile-sub-title
											v-html="'Obszar: ' + item.area"></v-list-tile-sub-title>
									</v-list-tile-content>
								</v-list-tile>
							</template>
							<template v-for="item in data.priorities">
								<v-list-tile :key="'priority-' + item.priorityId" avatar class="list-item">
									<v-list-tile-avatar>
										<v-icon>public</v-icon>
									</v-list-tile-avatar>
									<v-list-tile-content>
										<v-list-tile-title v-html="item.task + ' (' + item.country + ')'"
											style="font-size: 14px"></v-list-tile-title>
										<v-list-tile-sub-title
											v-html="'Priorytet: ' + item.priority"></v-list-tile-sub-title>
									</v-list-tile-content>
								</v-list-tile>
							</template>
						</v-list>
					</v-expand-transition>
				</v-flex>
			</v-layout>
			<v-layout row align-center>
				<v-flex xs1/>
				<v-flex xs3>
					<v-subheader><strong>Podział procentowy</strong></v-subheader>
				</v-flex>
				<v-flex xs4>
					<div v-for="item in percentagesList" v-bind:key="item.key"
						style="display: flex; flex-direction: row; justify-content: space-between">
						<span>{{item.key}}</span>
						<span>{{item.value}}</span>
					</div>
				</v-flex>
			</v-layout>
		</div>
	</div>
</template>

<script>
	import {Project} from "@/api/generated/Project";

	export default {
		name: "ProjectSummaryTasksView",

		data () {
			return {
				data: {},
				percentagesList: [],
				showList: false,
				dataLoaded: false
			};
		},

		created () {
			this.getProjectSummaryTasksData();
		},

		computed: {
			getListLabel () {
				return this.showList ? 'Ukryj listę zadań' : 'Wyświetl listę zadań';
			},

			getListIcon () {
				return this.showList ? 'keyboard_arrow_up' : 'keyboard_arrow_down';
			}
		},

		methods: {
			getProjectSummaryTasksData () {
				Project.getSummaryTasksData(this, this.$route.params.projectId, successResponse => {
						this.data = successResponse;
						this.percentagesList = [];
						for (let [k, v] of Object.entries(this.data.percentages)) {
							this.percentagesList.push({
								key: k,
								value: v + ' %'
							});
						}
						this.dataLoaded = true;
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się załadować zadań projektu", errorResponse);
					});
			},

			handleListExpansion () {
				this.showList = !this.showList;
			}
		}
	};
</script>

<style scoped>

</style>